import React, { Component } from 'react';
// components
import TopNav from '../../pages/Nav/LandingTopNav';
import Header from './Header';
import WhyItMatters from './WhyItMatters';
import HowItWorks from './HowItWorks';
import PowerfulFeatures from './PowerfulFeatures';
import SimplePricing from './SimplePricing';
import Footer from './Footer';

import './Landing.css';


class Landing extends Component {
  render() {
    return (
      <div className="Landing-container">
        <TopNav />
        <Header />
        <WhyItMatters />
        <HowItWorks />
        <PowerfulFeatures />
        <SimplePricing />
        <Footer />
      </div>
    );
  }
}

export default Landing;



// WEBPACK FOOTER //
// ./src/entries/Static/Landing.js